// 閲覧履歴に追加する関数を定義
function updateRecentProducts(productHandle) {
  const maxHistory = 6; // PCは5個、SPは6個表示するため「6」に変更
  let recentProducts = JSON.parse(localStorage.getItem('recentProducts')) || [];

  // 現在の商品がすでに存在する場合は除外
  recentProducts = recentProducts.filter(handle => handle !== productHandle);

  // 新しい履歴を追加
  recentProducts.unshift(productHandle);

  // 履歴の数を制限
  if (recentProducts.length > maxHistory) {
    recentProducts = recentProducts.slice(0, maxHistory);
  }

  // ローカルストレージに保存
  localStorage.setItem('recentProducts', JSON.stringify(recentProducts));
}

// 閲覧履歴を取得してフッターに描画する関数
async function renderRecentProducts() {
  const container = document.querySelector('.history_items_container');
  const section = document.querySelector('.footer_history_section');
  
  // フッターの履歴コンテナが存在しない場合は処理を終了
  if (!container || !section) return;

  const recentHandles = JSON.parse(localStorage.getItem('recentProducts')) || [];

  // 閲覧履歴が1件もない場合はHISTORYセクション自体を非表示にする
  if (recentHandles.length === 0) {
    section.style.display = 'none';
    return;
  }

  // 描画前に、HTML上のダミー要素をクリアする
  container.innerHTML = '';

  // 履歴のハンドルから商品データを順に取得
  for (let i = 0; i < recentHandles.length; i++) {
    const handle = recentHandles[i];
    try {
      // ShopifyのAjax APIを叩いて商品情報を取得
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) continue; // 商品が非公開・削除されている場合はスキップ
      const product = await response.json();

      // 画像URLの最適化（リサイズして読み込みを軽くする）
      const imageUrl = product.featured_image ? product.featured_image.replace(/(\.[^.]*)$/, "_400x400$1") : '';

      // 金額のフォーマット（ShopifyのAjax APIは「1000円=100000」で返すため100で割る）
      const price = Math.floor(product.price / 100).toLocaleString('ja-JP');

      // SP表示時の6番目のアイテムだけ非表示クラス(sp_history_item)を付与
      const spClass = (i === 5) ? ' sp_history_item' : '';

      // HTMLを生成して追加
      const itemHTML = `
        <a href="${product.url}" class="history_item${spClass}">
          <img src="${imageUrl}" class="history_item_image" alt="${product.title}" loading="lazy">
          <div class="history_item_brand">${product.vendor || ''}</div>
          <div class="history_item_name">${product.title}</div>
          <div class="history_item_price">¥${price} <span>税込</span></div>
        </a>
      `;
      container.insertAdjacentHTML('beforeend', itemHTML);

    } catch (error) {
      console.error('閲覧履歴の取得に失敗しました:', error);
    }
  }
}

// ページロード時に関数を呼び出し
document.addEventListener('DOMContentLoaded', function() {
  // 商品ページにいる場合のみ履歴を保存
  if (window.location.pathname.includes('/products/')) {
    const productHandle = window.location.pathname.split('/').pop();
    if (productHandle) {
      updateRecentProducts(productHandle);
    }
  }

  // どのページでも閲覧履歴セクションを描画
  renderRecentProducts();
});